/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAgentRequest = {
  agentId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetAgentRequest$inboundSchema: z.ZodType<
  GetAgentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetAgentRequest$Outbound = {
  agent_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetAgentRequest$outboundSchema: z.ZodType<
  GetAgentRequest$Outbound,
  z.ZodTypeDef,
  GetAgentRequest
> = z.object({
  agentId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getAgentRequestToJSON(
  getAgentRequest: GetAgentRequest,
): string {
  return JSON.stringify(GetAgentRequest$outboundSchema.parse(getAgentRequest));
}
export function getAgentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAgentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAgentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAgentRequest' from JSON`,
  );
}
